// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3M3dR","appList":"styles_appList__38uXP","app":"styles_app__3o-Li","logo":"styles_logo__5HwUm"};